import * as React from "react";
import AdsListGetter from "./AdsListGetter";
import AdsListRenderer from "./AdsListRenderer";


export interface AdvertisementsListProps {
  loading: boolean;
  adsData: Array<any>;
  totalCount: number;
  paginationModel: {
    page: number;
    pageSize: number;
  }
  setPaginationModel: React.Dispatch<React.SetStateAction<{
    page: number;
    pageSize: number;
  }>>;
  setRefreshTable: React.Dispatch<React.SetStateAction<number>>;

}

const AdvertisementsList: React.FC = () => {
  return (
    <AdsListGetter>{({ loading, adsData, totalCount, paginationModel, setPaginationModel, setRefreshTable }) =>
      <AdsListRenderer
        loading={loading}
        adsData={adsData}
        totalCount={totalCount}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        setRefreshTable={setRefreshTable}
      />}
    </AdsListGetter>
  );
};

export default AdvertisementsList;
